import { uniqBy } from 'lodash'

import {
    RemoteDocumentTypesDocument as query,
    RemoteDocumentTypesQuery,
    QueryResolvers,
} from '../../../../../generated/graphql'
import filterMaybe from '../../../../../utils/filterMaybe'

const documentTypesResolver: QueryResolvers['documentTypes'] = async (_root, _args, { client }) => {
    if (!client) {
        throw new Error('Missing ApolloClient')
    }

    const vtid = '1'

    const { data } = await client.query<RemoteDocumentTypesQuery>({
        query,
        variables: { verticalTypeId: vtid },
    })

    const allTypes = data.auction?.document?.documentTypes || []
    const filtered = allTypes
        .map((dt) => {
            return dt
                ? {
                      verticalTypeId: vtid,
                      docTypeName: dt.docTypeName,
                      docTypeId: dt.docTypeId,
                      displayOrder: dt.displayOrder,
                      shortCode: dt.shortCode,
                      __typename: 'DocType' as const,
                  }
                : null
        })
        .filter(filterMaybe)
    const uniqueIds = uniqBy(filtered, 'docTypeId')
    const uniqueShortCodes = uniqBy(uniqueIds, 'shortCode')

    return uniqueShortCodes
}

export default documentTypesResolver
